/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimEmailWithRecipients } from './ClaimEmailWithRecipients';
import {
    ClaimEmailWithRecipientsFromJSON,
    ClaimEmailWithRecipientsFromJSONTyped,
    ClaimEmailWithRecipientsToJSON,
    ClaimEmailWithRecipientsToJSONTyped,
} from './ClaimEmailWithRecipients';

/**
 * Single email with recipients
 * @export
 * @interface GetClaimEmailResponse
 */
export interface GetClaimEmailResponse {
    /**
     * 
     * @type {ClaimEmailWithRecipients}
     * @memberof GetClaimEmailResponse
     */
    email: ClaimEmailWithRecipients;
}

/**
 * Check if a given object implements the GetClaimEmailResponse interface.
 */
export function instanceOfGetClaimEmailResponse(value: object): value is GetClaimEmailResponse {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function GetClaimEmailResponseFromJSON(json: any): GetClaimEmailResponse {
    return GetClaimEmailResponseFromJSONTyped(json, false);
}

export function GetClaimEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClaimEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': ClaimEmailWithRecipientsFromJSON(json['email']),
    };
}

export function GetClaimEmailResponseToJSON(json: any): GetClaimEmailResponse {
    return GetClaimEmailResponseToJSONTyped(json, false);
}

export function GetClaimEmailResponseToJSONTyped(value?: GetClaimEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': ClaimEmailWithRecipientsToJSON(value['email']),
    };
}

